import { Box, Card, Text, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import MessagesTooltip from '../_Tooltip'

interface Props {
  name: string
  value: number | null | undefined
}

const MessagesStatBlock = ({ name, value }: Props) => {
  const [open, toggle] = useToggle(false)
  const numberIncidencePerStatus = value || 0
  const showTooltip = numberIncidencePerStatus > 0

  return (
    <Card>
      <Card.Content>
        <Box>
          <Text.Normal color="grey1000" weight="medium" size="200" ellipsis>
            {name}
          </Text.Normal>
        </Box>
        <Box flexDirection="row" alignItems="center">
          <Text color="grey1000" weight="semibold" size="500">
            {numberIncidencePerStatus}
          </Text>
          {showTooltip && (
            <Box justifyContent="spaceAround">
              <MessagesTooltip toggle={toggle} open={open} />
            </Box>
          )}
        </Box>
      </Card.Content>
    </Card>
  )
}

export default observer(MessagesStatBlock)
